import getData from './getData';
import getRequested from './getRequested';

export default (state, path) => {
  const dataByPath = getData(state);
  const requestedByPath = getRequested(state);
  return !dataByPath[path] && !requestedByPath[path];
};
